export const getMaxVisibleItems = <T>(
  items: T[],
  maxVisible: number,
): { displayItems: T[]; extraCount: number } => {
  const hasExtraItems = items.length > maxVisible;
  const displayItems = hasExtraItems ? items.slice(0, maxVisible) : items;
  const extraCount = items.length - maxVisible;

  return { displayItems, extraCount };
};
